import { render, staticRenderFns } from "./app-register-validate-fail.vue?vue&type=template&id=5a0851c8&scoped=true"
import script from "./app-register-validate-fail.vue?vue&type=script&lang=js"
export * from "./app-register-validate-fail.vue?vue&type=script&lang=js"
import style0 from "./app-register-validate-fail.vue?vue&type=style&index=0&id=5a0851c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0851c8",
  null
  
)

export default component.exports